import styled, { css } from 'styled-components';
import { useOrderAmountRankChart } from '../provider/OrderAmountRankChartProvider';
import { InequalityLeftBlue } from '../../../@icons/svg/InequalityLeftBlue';
import { InequalityLeftBlueDouble } from '../../../@icons/svg/InequalityLeftBlueDouble';
import { InequalityRightBlue } from '../../../@icons/svg/InequalityRightBlue';
import { InequalityRightBlueDouble } from '../../../@icons/svg/InequalityRightBlueDouble';
import {
  ChartContextEssType,
  ChartContextType,
} from '../provider/chartContextType';

export const ChartControllerEss = ({
  contextCall,
  title,
}: {
  contextCall: () => ChartContextEssType;
  title: string;
}) => {
  const { startDt, endDt } = contextCall();

  return (
    <Container>
      <TitleArea>
        <h3 style={{ margin: 0 }}>{title}</h3>
        <SubTitle>
          {startDt} ~ {endDt}
        </SubTitle>
      </TitleArea>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  margin-bottom: 13px;
`;

const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SubTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #b3b1b1;
`;
